import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px 40px 20px;
  display: flex;
  font-family: "Helvetica Neue", Arial, sans-serif;
`;

export default Container;
